import styled from 'styled-components'

const StyledLibra = styled.nav``

export default StyledLibra
